import * as React from 'react';

function SvgArrowDollar(props) {
  return (
    <svg
      width={41.016}
      height={284}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke="#cfcfcf"
        strokeWidth={3}
        strokeLinecap="round"
        d="M5.095 141.5h11"
      />
      <path
        stroke="#cfcfcf"
        strokeWidth={5}
        d="M11.168 17.011l-1.073 249.997"
      />
      <path
        d="M10.229.5a1 1 0 011.732 0l9.093 15.75a1 1 0 01-.866 1.5H2.001a1 1 0 01-.866-1.5zM10.96 283.5a1 1 0 01-1.731 0L.135 267.75a1 1 0 01.866-1.5h18.187a1 1 0 01.866 1.5z"
        fill="#cfcfcf"
      />
      <g>
        <path
          d="M24.4773 147.091V136.182H25.1761V147.091H24.4773ZM26.8295 139.455C26.7784 139.023 26.571 138.688 26.2074 138.449C25.8438 138.21 25.3977 138.091 24.8693 138.091C24.483 138.091 24.1449 138.153 23.8551 138.278C23.5682 138.403 23.3438 138.575 23.1818 138.794C23.0227 139.013 22.9432 139.261 22.9432 139.54C22.9432 139.773 22.9986 139.973 23.1094 140.141C23.223 140.305 23.3679 140.443 23.544 140.554C23.7202 140.662 23.9048 140.751 24.098 140.822C24.2912 140.891 24.4688 140.946 24.6307 140.989L25.517 141.227C25.7443 141.287 25.9972 141.369 26.2756 141.474C26.5568 141.58 26.8253 141.723 27.081 141.905C27.3395 142.084 27.5526 142.314 27.7202 142.595C27.8878 142.876 27.9716 143.222 27.9716 143.631C27.9716 144.102 27.848 144.528 27.6009 144.909C27.3565 145.29 26.9986 145.592 26.527 145.817C26.0582 146.041 25.4886 146.153 24.8182 146.153C24.1932 146.153 23.652 146.053 23.1946 145.851C22.7401 145.649 22.3821 145.368 22.1207 145.007C21.8622 144.646 21.7159 144.227 21.6818 143.75H22.7727C22.8011 144.08 22.9119 144.352 23.1051 144.568C23.3011 144.781 23.5483 144.94 23.8466 145.045C24.1477 145.148 24.4716 145.199 24.8182 145.199C25.2216 145.199 25.5838 145.134 25.9048 145.003C26.2259 144.869 26.4801 144.685 26.6676 144.449C26.8551 144.21 26.9489 143.932 26.9489 143.614C26.9489 143.324 26.8679 143.088 26.706 142.906C26.544 142.724 26.331 142.577 26.0668 142.463C25.8026 142.349 25.517 142.25 25.2102 142.165L24.1364 141.858C23.4545 141.662 22.9148 141.382 22.517 141.018C22.1193 140.655 21.9205 140.179 21.9205 139.591C21.9205 139.102 22.0526 138.676 22.3168 138.312C22.5838 137.946 22.9418 137.662 23.3906 137.46C23.8423 137.256 24.3466 137.153 24.9034 137.153C25.4659 137.153 25.9659 137.254 26.4034 137.456C26.8409 137.655 27.1875 137.928 27.4432 138.274C27.7017 138.621 27.8381 139.014 27.8523 139.455H26.8295ZM32.6239 137.273V146H31.5671V138.381H31.516L29.3853 139.795V138.722L31.5671 137.273H32.6239Z"
          fill="#818181"
        />
      </g>
    </svg>
  );
}

export default SvgArrowDollar;
